<template>
  <section>
    <div class="metadata-row is-flex is-align-items-center m-l-10">
      <SkeletonView height="20" width="20" circle class="m-r-30" />
      <SkeletonView height="20" width="20" circle class="m-r-40" />
      <template v-if="isExpandedView">
        <SkeletonView height="14" width="100" rounded class="m-r-35" />
      </template>
      <SkeletonView height="14" width="80" rounded />
    </div>
  </section>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraMetadataSkeleton',
  components: { SkeletonView },
  props: {
    isExpandedView: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.b-skeleton + .b-skeleton {
  margin-top: 0 !important;
}
.metadata-row {
  gap: var(--ce-25px);
}
.metadata-row :deep(.b-skeleton) {
  flex-shrink: 0;
  width: auto !important;
}
</style>
